import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "../lib/api";
import { catLabel as fallbackLabel } from "../lib/i18n";

const CategoryContext = createContext(null);

/**
 * Kataloq strukturu serverdən gəlir və admin panelindən idarə olunur.
 * Kateqoriya adlarını heç bir yerdə hardcode etmə — bu konteksti işlət.
 */
export const CategoryProvider = ({ children }) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = () =>
    api
      .get("/categories")
      .then(({ data }) => setGroups(data.groups || []))
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));

  useEffect(() => {
    reload();
  }, []);

  const value = useMemo(() => {
    const byKey = {};
    groups.forEach((g) => {
      byKey[g.key] = g;
      (g.children || []).forEach((c) => {
        byKey[c.key] = c;
      });
    });

    return {
      groups,
      loading,
      reload,
      // Bütün alt kateqoriyalar (qruplar daxil deyil)
      allCategories: groups.flatMap((g) => g.children || []),
      childrenOf: (groupKey) =>
        (groups.find((g) => g.key === groupKey) || {}).children || [],
      // Server adı varsa onu, yoxsa köhnə i18n lüğətini işlədir
      label: (key, lang) => {
        const node = byKey[key];
        if (!node) return fallbackLabel(key, lang);
        return (lang === "en" ? node.name_en : node.name_az) || node.name_az || key;
      },
    };
  }, [groups, loading]);

  return <CategoryContext.Provider value={value}>{children}</CategoryContext.Provider>;
};

export const useCategories = () => {
  const ctx = useContext(CategoryContext);
  if (!ctx) throw new Error("useCategories CategoryProvider daxilində işlədilməlidir");
  return ctx;
};
